module.exports = __webpack_public_path__ + "static/media/banner1.9b4c74f5.png";